module.exports = __webpack_public_path__ + "static/media/taskList.c47e03c5.png";